import { OnInit, Directive } from '@angular/core';

@Directive()
export abstract class AbstractModal implements OnInit {
  constructor() {}

  ngOnInit() {}
}
